function addToCart(e) { 
  e.preventDefault(); 
  e.stopPropagation(); 
  window.add_to_cart(e);
}

function quantityAction(e) {
  e.preventDefault();
  window.quantityAction(e);
}

function inputChange(e) {
  e.preventdefault();
  window.inputChange(e);
}

function inputFocus(e) {
  e.stopPropagation();
}

document.addEventListener('algolia.hooks.initialize', function() {
   algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
    // Change the placeholder text of the autocomplete menu
    options.placeholder = "¿Qué desearías buscar hoy?";
    options.openOnFocus = true;
    return options;
  });
  
  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
    return html`
      <div class="ais-page">
        <h1 class="ais-h2" style="display: none">${algoliaShopify.translations.searchTitle}</h1>
        <div class="ais-input" style="display: none">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-facets-button">
          ${algoliaShopify.translations.showFilters}
        </div>
        <div class="ais-facets">
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          ${data.facets.map(
            facet =>
              html`
                <div
                  class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                >
                  <label
                    for="${facet.escapedName}"
                    class="ais-range-slider--header ais-facet--header ais-header"
                    >${facet.title}</label
                  >
                  <input
                    class="ais-dropdown-checkbox"
                    type="checkbox"
                    id="${facet.escapedName}"
                    name="dropdown"
                  />
                  <div
                    class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                  ></div>
                </div>
              `
          )}
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display"><span class="ais-change-display-block ais-change-display-selected" role="button" aria-pressed="true" aria-label="grid display"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1664 1450"><path d="M768 512v-384q0-52-38-90t-90-38h-512q-52 0-90 38t-38 90v384q0 52 38 90t90 38h512q52 0 90-38t38-90zM768 1280v-384q0-52-38-90t-90-38h-512q-52 0-90 38t-38 90v384q0 52 38 90t90 38h512q52 0 90-38t38-90zM1664 512v-384q0-52-38-90t-90-38h-512q-52 0-90 38t-38 90v384q0 52 38 90t90 38h512q52 0 90-38t38-90zM1664 1280v-384q0-52-38-90t-90-38h-512q-52 0-90 38t-38 90v384q0 52 38 90t90 38h512q52 0 90-38t38-90z"></path></svg></span><span class="ais-change-display-list" role="button" aria-pressed="false" aria-label="list display"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1792 1450"><path d="M512 288v-192q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v192q0 40 28 68t68 28h320q40 0 68-28t28-68zM512 800v-192q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v192q0 40 28 68t68 28h320q40 0 68-28t28-68zM1792 288v-192q0-40-28-68t-68-28h-960q-40 0-68 28t-28 68v192q0 40 28 68t68 28h960q40 0 68-28t28-68zM512 1312v-192q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v192q0 40 28 68t68 28h320q40 0 68-28t28-68zM1792 800v-192q0-40-28-68t-68-28h-960q-40 0-68 28t-28 68v192q0 40 28 68t68 28h960q40 0 68-28t28-68zM1792 1312v-192q0-40-28-68t-68-28h-960q-40 0-68 28t-28 68v192q0 40 28 68t68 28h960q40 0 68-28t28-68z"></path></svg></span></div>
            <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`
                    ${algoliaShopify.translations.sortBy}
                    <span class="ais-sort-orders-container"></span>
                  `
                : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;
  });
});

document.addEventListener('algolia.hooks.initialize', function() {
  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components, trackSearchAttribution) {
    const hitImage = algoliaShopify.helpers.renderImage(hit, 250);
    return html`
      <div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        onClick="${() => trackSearchAttribution(hit)}"
      >
        <img
          class="ais-hit--picture"
          src="${hitImage.src}"
          srcset="${hitImage.srcset}"
          sizes="${hitImage.sizes}"
          alt="${hit.title} - ${hit.variant_title}"
        />

        <div class="ais-hit--details">
        <div class="text-container">
          <p class="ais-hit--title product-item__title text--strong link">
            <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              title="${algoliaShopify.helpers.fullTitle(
                hit.title,
                hit._distinct,
                hit.variant_title
              )}"
            >
              ${components.Highlight({ attribute: 'title', hit })}
              ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
            </a>
          </p>
          <p style="display: none"
            class="ais-hit--subtitle"
            title="${hit.product_type}${algoliaShopify.translation_helpers.by(
              hit.vendor
            )}"
          >
            ${components.Highlight({ attribute: 'product_type', hit })}
            ${hit.vendor &&
              html`
                <span> ${algoliaShopify.translations.by} </span>
              `}
            ${hit.vendor && components.Highlight({ attribute: 'vendor', hit })}
          </p>
          <p class="ais-hit--price product-item__price-list price-list">
            <img src="//madisoncenter.com/cdn/shop/t/45/assets/logo-max-center_512x.png?v=38020612259249841541746280391" />
            <b>${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</b>
            ${!hit._distinct &&
              html`
                <span class="ais-hit--price-striked"
                  ><span
                    >${algoliaShopify.helpers.displayStrikedPrice(
                      hit.price,
                      hit.comparje_at_price
                    )}</span
                  ></span
                >
              `}
            ${!hit._distinct &&
              html`
                <span class="ais-hit--price-discount"
                  >${algoliaShopify.helpers.displayDiscount(
                    hit.price,
                    hit.compare_at_price,
                    hit.price_ratio
                  )}</span
                >
              `}
          </p>
          <!-- Extra info examples - Remove the display: none to show them -->
          <p class="ais-hit--info" style="display: none">
            ${hit.sku &&
              html`
                <span class="algolia-sku"
                  >${components.Highlight({ attribute: 'sku', hit })}</span
                >
              `}
            ${hit.barcode &&
              html`
                <span class="algolia-barcode"
                  >${components.Highlight({ attribute: 'barcode', hit })}</span
                >
              `}
            ${hit.weight &&
              html`
                <span class="algolia-weight">${hit.weight}</span>
              `}
            ${!hit.taxable &&
              html`
                <span class="algolia-taxable"
                  >${algoliaShopify.translations.taxFree}</span
                >
              `}
          </p>
          <!-- Tags example - Remove the display: none to show them -->
          <p class="ais-hit--tags" style="display: none">
            ${hit?._highlightResult.tags?.map(
              tag =>
                html`
                  <span class="ais-hit--tag">${tag.value}</span>
                `
            )}
          </p>
          </div>
          ${(!hit._distinct || hit.variants_count <= 1) ?
            html`
                <p class="ais-hit--cart">
                  ${hit.can_order
                    ? html`
                      <form
                          id="algolia-add-to-cart-${hit.objectID}"
                          action="/cart/add"
                          method="post"
                          enctype="multipart/form-data"
                        >
                          <input type="hidden" name="id" value="${hit.objectID}" />
                        <div class="product-item__add-to-cart">
                          <button
                            class="ais-hit--cart-button"
                            data-form-id="algolia-add-to-cart-${hit.objectID}"
                            onClick="${(e) => addToCart(e)}"
                          >
                            ${algoliaShopify.translations.addToCart}
                          </button>
                        <div class="product-item__quantity-selector product-item__action-button button d-none button--small button--primary" 
                          data-product-image="${hitImage.src}" 
                          data-product-title="${hit.title}"
                        >
                          <div class="product-item__quantity-selector--minus product-item__quantity-selector--action" onClick="${(e) => quantityAction(e)}">
                            -
                          </div>
                          <input type="text" name="quantity_selector" class="product-item__quantity-selector--input" data-value="1" value="1" min="1" onFocus="${(e) => inputFocus(e)}" onChange="${(e) => inputChange(e)}" />
                          <div class="product-item__quantity-selector--plus product-item__quantity-selector--action" onClick="${(e) => quantityAction(e)}">+</div>
                        </div>
                      </div>
                      </form>
                      `
                    : html`
                        <button
                          class="ais-hit--cart-button ais-hit--cart-button__disabled"
                        >
                          ${algoliaShopify.translations.outOfStock}
                        </button>
                      `}
                </p>
                `
            : html`
              <button
                class="ais-hit--cart-button "
              >
                <span>Escoger opciones</span>
              </button>
            `}
        </div>
      </div>
    `;
  });
});

document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      // Modify default options, then return them
      const { html, item, components } = templateOptions;
      return html`
    <a
      href="${itemLink}"
      class="aa-ItemLink aa-ProductItem"
      onClick="${() => trackSearchAttribution(item)}">
      <div class="aa-ItemContent">
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
          <img
            src="${algoliaShopify.helpers.renderImage(item, 125).src}"
            srcset="${algoliaShopify.helpers.renderImage(item, 125).srcset}"
            sizes="${algoliaShopify.helpers.renderImage(item, 125).sizes}"
            alt="${item.title}" />
        </div>
        <div class="aa-ItemContentBody">
          <div class="aa-ItemContentBrand">
            ${
              item.product_type &&
              components.Highlight({ hit: item, attribute: "product_type" })
            }
           removing vendor
          </div>
          <div class="aa-ItemContentTitleWrapper">
            <div class="aa-ItemContentTitle">
              ${components.Highlight({ hit: item, attribute: "title" })}
              <span class="algolia-variant">
                ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
              </span>
            </div>
          </div>
          <div class="aa-ItemContentPrice product-item__price-list price-list">
            <img src="//madisoncenter.com/cdn/shop/t/45/assets/logo-max-center_512x.png?v=38020612259249841541746280391" />
            <div class="aa-ItemContentPriceCurrent">
              ${algoliaShopify.helpers.displayPrice(item, distinct)}
            </div>
          </div>

          <form
              id="algolia-add-to-cart-${item.objectID}"
              action="/cart/add"
              method="post"
              enctype="multipart/form-data"
            >
            <input type="hidden" name="id" value="${item.objectID}" />
            <div class="product-item__add-to-cart">
              
              <button
                class="ais-hit--cart-button"
                data-form-id="algolia-add-to-cart-${item.objectID}"
                onClick="${(e) => addToCart(e)}"
              >
                ${algoliaShopify.translations.addToCart}
              </button>
              <div class="product-item__quantity-selector product-item__action-button button d-none button--small button--primary" 
                data-product-image="${algoliaShopify.helpers.renderImage(item, 125).src}" 
                data-product-title="${item.title}"
              >
                <div class="product-item__quantity-selector--minus product-item__quantity-selector--action" onClick="${(e) => quantityAction(e)}">
                  -
                </div>
                <input type="text" name="quantity_selector" class="product-item__quantity-selector--input" data-value="1" value="1" min="1" onFocus="${(e) => inputFocus(e)}" onChange="${(e) => inputChange(e)}" />
                <div class="product-item__quantity-selector--plus product-item__quantity-selector--action" onClick="${(e) => quantityAction(e)}">+</div>
              </div>
          </div>
        </form>
        </div>
      </div>
    </a>
  `;
    }
  );
});

// document.addEventListener('algolia.hooks.initialize', function() {
//   algoliaShopify.hooks.registerHook('beforeAutocompleteMainTemplate', function(_defaultTemplate, templateOptions, elements, displaySuggestions) {
//     const { html } = templateOptions;
//     // Don't return the default template and return a custom two-column layout instead
//     return html`
//       <div class="aa-PanelLayout aa-Panel--scrollable">
//         <div class="aa-PanelSections">
//           <div class="aa-PanelSection--left">
//             ${displaySuggestions &&
//               html`
//                 <div class="aa-SourceHeader">
//                   <span class="aa-SourceHeaderTitle"
//                     >${algoliaShopify.translations.suggestions}</span
//                   >
//                   <div class="aa-SourceHeaderLine" />
//                 </div>
//                 ${elements.querySuggestionsPlugin}
//               `}
//             ${elements.collections} ${elements.articles} ${elements.pages}
//             ${elements.redirectUrlPlugin}
//           </div>
//           <div class="aa-PanelSection--right">
//             ${elements.products}
//           </div>
//         </div>
//       </div>
//     `;
//   });
// });

